<template>
  <div v-if="list.length > 0"
       class="actions"
  >
    <div v-for="(item ,key, index) in list"
         :key="key"
         class="stackable-action"
    >
      <i class="icon-3x icon-sync icon-spin"
         width="40"
         height="40"
      />
      <span>
        {{ item.text }}
      </span>
      <i :key="key + index"
         class="lg icon-down-arrow"
         @click="close(index)"
      />
    </div>
  </div>
</template>

<script>
import Vue from 'vue';

export default {
  name: 'StackableActions',
  props: {},
  data() {
    return {
      list: [],
    };
  },
  mounted() {
    Vue.prototype.$stackableActionsOpen = this.open;
  },
  methods: {
    open(settings, request) {
      if (this.list.length === 3) return false;
      this.list = [...this.list, settings];
      request.finally((response) => {
        const index = this.list.indexOf(settings);
        this.list.splice(index, 1);
        return response;
      });
    },
    close(index) {
      this.list.splice(index, 1);
    },
  },
};
</script>

<style lang="scss" scoped>
.actions {
  width: auto;
  bottom: 0;
  left: 50%;
  transform: translate(-50%, 0%);
  position: fixed;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 1024;
  .stackable-action {
    display: inline-flex;
    align-items: center;
    height: 76px;
    width: 480px;
    margin-bottom: 1rem;
    color: black;
    background-color: white;
    box-shadow: 0 0 0 1px #e6e6e6;
    &:last-child {
      margin-bottom: 80px;
    }
    .icon-sync {
      padding: 16px;
    }
    .icon-down-arrow {
      color: gray;
      padding: 16px;
      margin-left: auto;
    }
  }
}
</style>
